<template>
  <div class="informationTemplate-tree-bd">
    <el-dialog v-drag-dialog :title="model.title" :visible.sync="visible" :before-close="closeDialog" :close-on-click-modal="false" width="500px">
      <div class="dialog-body">
        <!-- 用户信息 -->
        <el-form :model="form" ref="form">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('crm_partner_password_dialog.glymc')">
                <el-input v-model="form.oldadminName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('crm_partner_password_dialog.glydlm')">
                <el-input v-model="form.oldAdminLoginName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('crm_partner_password_dialog.mi_ma')" prop="newPwd" :rules="rules.newPwd">
                <el-input type="password" v-model="form.newPwd"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('crm_partner_password_dialog.que_ren_mi_ma')" prop="confirmPwd" :rules="rules.confirmPwd">
                <el-input type="password" v-model="form.confirmPwd"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="savePassword">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    data: [String, Object, Array],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
  },
  data() {
    return {
      visible: false,
      form: {
        oldadminName: '',
        oldAdminLoginName: '',
        userId: '',
        newPwd: '',
        confirmPwd: '',
      },
      // 分组类型禁用开关
      // groupLevelOff: false,
      parentIdOff: false,
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.initDialog();
    this.rules.newPwd[1].validator = (rule, value, callback) => {
      const reg = /(?!.*\s)(?!^[\u4e00-\u9fa5]+$)(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/;
      if (!reg.test(value.toString())) {
        callback(new Error());
      } else {
        callback();
      }
    };
    this.rules.confirmPwd[0].validator = (rule, value, callback) => {
      if (value !== this.form.newPwd) {
        callback(new Error());
      } else {
        callback();
      }
    };
  },

  computed: {
    rules() {
      return {
        newPwd: [
          {
            min: 8,
            max: 16,
            message: this.$t('crm_partner_password_dialog.cdyz816gzfszfhzmrylz'),
          },
          {
            validator: null,
            message: this.$t('crm_partner_password_dialog.bxbhszfhzmrylz'),
          },
        ],
        confirmPwd: [{ required: true, validator: null, message: this.$t('crm_partner_password_dialog.lcsrmmbyz') }],
      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.form = JSON.parse(this.resetForm);
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      if (this.model.type === 'edit') {
        this.form.oldadminName = this.data.adminName;
        this.form.oldAdminLoginName = this.data.adminLoginName;
        this.form.userId = this.data.adminId;
      }
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },

    // 确认保存分组
    savePassword: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.saveEditPassword();
      });
    },
    // 保存编辑分组
    saveEditPassword: function () {
      this.$postJSON(apis.partnerOrganAdminPwd, { ...this.form, newPwd: this.encrypt(this.form.newPwd), confirmPwd: this.encrypt(this.form.confirmPwd) }).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('Common.com_modify_success'),
            type: 'success',
          });
          this.closeDialog();
          this.$emit('success', this.form);
        }
      });
    },
  },
};
</script>

<style lang="scss"></style>
